import { IconContext } from 'react-icons'
import { CgSpinner } from 'react-icons/cg'
import { getCompanyPermissionObject } from './helpers'

// Set
export const setUserData = (data) => {
  localStorage.setItem('userData', JSON.stringify(data))
}
export const setUserToken = (token) => {
  localStorage.setItem('token', token)
}
export const setCompany_storage = (data) => {
  localStorage.setItem('company', JSON.stringify(data))
}
export const setCategoryViewFormat = (data) => {
  localStorage.setItem('category_view_format', data)
}
export const setMenuWidth = (data) => {
  localStorage.setItem('mainmenu_width', data)
}

// Get
export const getUserToken = () => {
  return localStorage.getItem('token')
}
export const getUserData = () => {
  return JSON.parse(localStorage.getItem('userData'))
}
export const getCompany_storage = () => {
  if (localStorage.getItem('company') !== 'undefined' && localStorage.getItem('company')) {
    return JSON.parse(localStorage.getItem('company'))
  } else {
    return null
  }
}
export const getCategoryViewFormat = () => {
  return localStorage.getItem('category_view_format')
}
export const getMenuWidth = () => {
  return localStorage.getItem('mainmenu_width')
}

// Unset
export const unsetUserData = () => {
  localStorage.removeItem('userData')
}
export const unsetUserToken = () => {
  localStorage.removeItem('token')
}
export const unsetCompany = () => {
  localStorage.removeItem('company')
}
export const unsetCategoryViewFormat = () => {
  localStorage.removeItem('category_view_format')
}
export const unsetMenuWidth = () => {
  localStorage.removeItem('mainmenu_width')
}

// Get
export const getLocalStorageValue = async (key) => {
  return Promise.resolve(localStorage.getItem(key))
}
// Set
export const setLocalStorageValue = (key, data) => {
  localStorage.setItem(key, data)
  return Promise.resolve()
}
// Unset
export const unsetLocalStorageValue = async (key) => {
  localStorage.removeItem(key)
  return Promise.resolve()
}

export const SUBSCRIPTION_AMOUNT = 15

export const lazyLoader = () => <></>

export const convertObjectToQuerystring = (obj) => {
  return Object.keys(obj)
    .map((key) => key + '=' + obj[key])
    .join('&')
}

export const passwordPattern = /^(?=.*\d)(?=.*[*.!@$%^&(){}[])(?=.*[a-zA-Z]).{8,}$/

export const ButtonLoader = () => {
  return (
    <span className='d-inline-block'>
      <IconContext.Provider value={{}}>
        <div className='spinner d-flex'>
          <i className='spin'>
            <CgSpinner />
          </i>
        </div>
      </IconContext.Provider>
    </span>
  )
}

export const PageLoader = ({ width, height }) => {
  return (
    <div className='p-5'>
      <div className='d-flex justify-content-center'>
        <i className='spin'>
          <IconContext.Provider value={{ style: { width: width || 30, height: height || 30 } }}>
            <CgSpinner />
          </IconContext.Provider>
        </i>
      </div>
    </div>
  )
}

export const PageContentTable = ({ contentTable }) => (
  <div className='p-3'>
    <ul className='table-of-contents'>
      {contentTable.length === 0 && <li className='text-muted text-center'>Page headers appear here.</li>}
      {contentTable.map((heading, i) => (
        <li key={i} className={`mb-0 ${heading.headingClass} ${heading.levelClass}`}>
          <a
            href={`#${heading.headingLink}`}
            onClick={(e) => {
              e.preventDefault()
              const frView = document.querySelector('.content-wrapper .fr-view')
              const headingNodes = frView.querySelectorAll('h1,h2,h3,h4')
              // const frWrapper = document.querySelector('.fr-view')
              const target_id = e.target.hash.split('_')
              const i = target_id[2]
              if (frView) {
                frView.scrollTo(0, headingNodes[i].offsetTop)
                window.scrollTo(0, headingNodes[i].offsetTop)
              }
            }}>
            {heading.textContent}
          </a>
        </li>
      ))}
    </ul>
  </div>
)

export const getDefaultSharingOnEdit = (access, item) => {
  const company = getCompany_storage()
  if (item.shared_users?.length > 0) {
    return item.shared_users
      .filter((u) => u.access === access)
      .map((u) => {
        if (u.user_id) {
          return { ...u.user, user_id: u.user_id, name: u.user.name, value: u.company_member.member_code, option_type: 'user' }
        } else if (u.team_id) {
          return { ...u.team, team_id: u.team_id, name: `Team: ${u.team.name}`, value: u.team.uuid, option_type: 'team' }
        } else {
          return getCompanyPermissionObject(company)
        }
      })
  } else {
    return []
  }
}

// Page Count
export const getPagesCount = (category) => {
  let length = category.pages.length
  if (category.subcategories.length > 0) {
    for (const sub_cat of category.subcategories) {
      length = length + getPagesCount(sub_cat)
    }
  }
  return length
}

export const isFormValid = (formik) => {
  return !formik.isValid || Object.keys(formik.touched).length === 0
}
